<template>
    <form class="py-12" v-on:submit.prevent="prevent">
        <v-slide-x-transition>
            <v-card class="mx-auto my-3" max-width="600" :loading="loading">
                <v-card-title class="px-6 pt-6">
                    {{ $t('auth.user.title') }}
                </v-card-title>
                <v-card-text class="px-6">
                    <v-text-field v-model="email" ref="email" :error-messages="emailErrors" :label="$t('auth.user.email.label')" required
                        @input="v$.email.$touch()" @blur="v$.email.$touch()" @keyup.enter="submit"></v-text-field>

                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                    <v-btn class="mr-4 mb-2" color="primary" @click="submit" type="button" large elevation="0"
                        :disabled="v$.email.$invalid && v$.email.$dirty" :loading="processing">
                        {{ $t('auth.buttons.continue') }}
                    </v-btn>
                </v-card-actions>
                <v-divider></v-divider>
                <v-card-actions class="mx-3">
                    {{ $t('auth.user.register') }}<v-btn text to="/cadastrar">{{ $t('auth.user.cta') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-slide-x-transition>
    </form>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import axios from 'axios'
export default {
    setup() {
        return { v$: useVuelidate() }
    },
    validations: {
        email: { required, email},
    },
    data: () => ({
        processing: false,
        loading: false,
        errors: [],
        email: '',
    }),
    watch: {
        email(){
            this.errors = []
        }
    },  

    computed: {
        emailErrors() {
            const errors = []
            if (!this.v$.email.$dirty) return errors

            this.v$.email.email.$invalid && errors.push(this.$t('auth.user.email.errors.email'))
            this.v$.email.required.$invalid && errors.push(this.$t('auth.user.email.errors.required'))
            this.errors.forEach((error) => {
                errors.push(this.$t(error))
            })
            return errors
        }
    },
    mounted(){
        this.$refs.email.focus();
    },

    methods: {
        prevent(event) {
            event.stopPropagation()
        },
        submit() {
            this.processing = true;
            this.v$.$touch()
            if (this.v$.$invalid == false) {
                axios.create({
                    headers: {
                        "Content-Type": "application/json",
                    },
                    });
                axios.post(`${this.$apiURL}assets/checker/email`, { value: this.email, input: 'email', isPublisher: true }
                ).then((response) => {
                    this.processing = false
                    if (!response.data.data.available && response.data.data.user.length) {
                        const User = response.data.data.user[response.data.data.user.length-1]
                        User.email = this.email
                        this.$emit('setUser', User)
                    }
                    else {
                        this.$emit('error', {
                            text: this.$t('auth.user.email.errors.noAccount'),
                            show: true
                        })
                        this.errors.push('auth.user.email.errors.noAccount')
                    }
                }, () => {
                    this.$emit('error', {
                        text: this.$t('auth.user.email.errors.generic'),
                        show: true
                    })
                    this.errors.push('auth.user.email.errors.generic')
                });
            }
            else{
                this.processing = false
            }
        }
    },
}
</script>